import BillableFilters from "./filters";
import List from "components/list";
import React from "react";
import { JobCell, ProjectCell } from "./cells";
import { usePermissions } from "contexts/permission";
import { EmployeeCell } from "components/cell/employee/cell";
import { StatusCell } from "@/components/status/cell";
import TypeCell from "@/components/type/cell";
import { AmountCell } from "@/components/cells/amount";
import { DateCell } from "@/components/date/cell";
import BillableName from "@/components/billable/cells/name";
import { ROUTE } from "@/lib/utils";
import { getEmployeeFields } from "components/user/config";

const defaultFilters = {
  status: {
    _neq: "archived",
  },
};

const deep = {
  extensions: {
    _sort: ["date_created"],
  },
};

const customSearch = (search) => ({
  _or: [
    { name: { _icontains: search } },
    { type: { _icontains: search } },
    { job: { name: { _icontains: search } } },
    { job: { project: { name: { _icontains: search } } } },
  ],
});

export default function Billables() {
  const permissions = usePermissions();

  const baseFields = [
    "id",
    "name",
    "type",
    "job.name",
    "job.project.name",
    "status",
    "billing_date",
    "due_date",
    "extensions.billing_date",
    "extensions.start_date",
    {
      job: [
        "id",
        getEmployeeFields("coordinator"),
        {
          project: [
            getEmployeeFields("account_manager"),
            getEmployeeFields("sales_coordinator"),
            "project_id",
          ],
        },
      ],
    },
  ];

  const canReadAmount = permissions.hasFieldAccess(
    "billables",
    "read",
    "amount",
  );

  const fields = [
    ...baseFields,
    ...(canReadAmount ? ["amount", "currency.name", "adjusted_amount"] : []),
  ];

  const columns = [
    {
      id: "name",
      header: "Name",
      accessorKey: "name",
      cell: BillableName,
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "type",
      header: "Type",
      accessorKey: "type",
      cell: TypeCell,
    },
    {
      id: "amount",
      header: "Amount",
      accessorKey: "amount",
      cell: AmountCell,
      field: "amount",
    },

    {
      id: "job.project.name",
      header: "Project",
      accessorKey: "job.project.name",
      href: (row) => ROUTE.PROJECT(row?.job?.project?.project_id),
      cell: ProjectCell,
    },
    {
      id: "job.name",
      header: "Job",
      accessorKey: "job.name",
      href: (row) => ROUTE.JOB(row?.job?.id),
      cell: JobCell,
    },
    {
      id: "billing_date",
      header: "Billing Date",
      accessorKey: "billing_date",
      sortable: true,
      cell: DateCell,
    },
    {
      id: "due_date",
      header: "Due By",
      accessorKey: "due_date",
      sortable: true,
      cell: DateCell,
    },
    {
      id: "job-coordinator",
      header: "JC",
      accessorKey: "job.coordinator",
      cell: EmployeeCell,
    },
    {
      id: "project-account-manager",
      header: "AM",
      accessorKey: "job.project.account_manager",
      cell: EmployeeCell,
    },
    {
      id: "project-sales-coordinator",
      header: "SC",
      accessorKey: "job.project.sales_coordinator",
      cell: EmployeeCell,
    },
  ];



  return (
    <List
      title="Billables"
      endPoint="billables"
      storageKey="billables"
      filters={defaultFilters}
      columns={columns}
      meta={{ fields, deep, customSearch }}
      sortby="billing_date"
      renderFilters={BillableFilters}
      href={(item) => item.id}
    />
  );
}
